module.exports = __webpack_public_path__ + "static/media/bw.55beba47.jpg";